import { AbgSxProps } from '@abg/typings';

export const userCardsAmountWrapperStyles: AbgSxProps = {
  display: 'flex',
  gap: { xs: '8px', sm: '24px' },
};

export const userCardsAmountBoxStyles: AbgSxProps = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
};

export const boldTextStyles: AbgSxProps = {
  textAlign: 'center',
};

export const redTextStyles: AbgSxProps = {
  color: '#D4002A',
};

export const editIconStyles: AbgSxProps = {
  fontSize: '16px',
  color: 'text.primary',
  cursor: 'pointer',
  mt: '2px',
};

export const amountEditContainerStyling: AbgSxProps = {
  display: 'flex',
  flexDirection: 'row',
  gap: '2px',
};
